import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import cx from 'classnames';
import { withStyles } from '@material-ui/core/styles';

// styles
import styles from './styles';

const CloseModalButton = ({ classes, handleCloseModal, placement }) => (
  <div className={cx(classes.wrapper, placement === 'inside' && classes.wrapperInside)}>
    <button
      type="button"
      aria-label="Close"
      className={cx(classes.closeButton, placement === 'inside' && classes.closeButtonInside)}
      onClick={handleCloseModal}
    >
      <span />
      <span />
    </button>
  </div>
);

CloseModalButton.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  placement: PropTypes.oneOf(['inside']),
};

CloseModalButton.defaultProps = {
  placement: undefined,
};

export default compose(withStyles(styles), memo)(CloseModalButton);
